// Module
var code = `<div class="row form-group"> <div class="col-sm-12"> <label> <span translate>Expense Type</span> <select class="form-control" ng-model="currentPayment.expenseType" ng-options="key as value for (key , value) in expenseTypesConstants"></select> </label> </div> </div> `;
// Exports
var _module_exports =code;;
var path = '/scripts/directives/payment/paymentMethods/additionalExpense.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;